/** Периодичность опроса — раз в 5 минут, плюс внеочередная проверка при возврате фокуса на вкладку. */
export const VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

export const RELOAD_COOLDOWN_MS = 60 * 1000;
export const RELOAD_COOLDOWN_STORAGE_KEY = "version_check_reload_at";

export const SHOWN_FLAG_STORAGE_PREFIX = "update_notice_shown_v";

export const BUILD_VERSION_META_NAME = "app-build-version";

export const VERSION_ENDPOINT = "/api/version";
